import Card from "./Card";
import { cn } from "../../lib/cn";

/**
 * Phase 2 primitive — `<Panel>` + `<PanelHead>` + `<PanelRow>` replace
 * `.panel`, `.panel-head`, `.panel-title`, `.panel-link`, `.panel-row`
 * from common-ui.css. Panel is the grouped-content card with a section
 * header bar and uniformly bordered rows. Rows can be clickable
 * (hover-highlight) or purely layout.
 */

export function Panel({ children, className }) {
  return <Card variant="panel" className={className}>{children}</Card>;
}

export function PanelHead({ title, right }) {
  return (
    <div className="flex items-center justify-between px-5 py-4 border-b border-rc-border bg-rc-surface">
      <div className="text-xs font-bold uppercase tracking-[0.1em] text-rc-text-secondary">
        {title}
      </div>
      {right}
    </div>
  );
}

export function PanelLink({ onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-xs font-semibold text-rc-accent-strong cursor-pointer hover:underline bg-transparent border-0"
    >
      {children}
    </button>
  );
}

export function PanelRow({ onClick, className, children }) {
  const interactive = typeof onClick === "function";
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-center justify-between px-5 py-[13px] border-b border-rc-border",
        "last:border-b-0",
        interactive && "cursor-pointer transition-colors hover:bg-rc-surface-hover",
        className,
      )}
    >
      {children}
    </div>
  );
}
